/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkingModeActivityWritePath =
  (typeof WorkingModeActivityWritePath)[keyof typeof WorkingModeActivityWritePath];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingModeActivityWritePath = {
  module_content: 'module_content',
  module_operational: 'module_operational',
  task_content: 'task_content',
  job: 'job',
} as const;
